// extracted by mini-css-extract-plugin
export default {"elixir-footer":"ElixirFooter_style__elixir-footer___a0","logo":"ElixirFooter_style__logo___f2","readmore":"ElixirFooter_style__readmore___a1"};